import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import AlarmsTabPane from './AlarmsTabPane';
import ProductSelectionTabPane from './ProductSelectionTabPane';
import PersonalData from './PersonalData';

import { forEachObjIndexed } from 'ramda';

import { Layout, Tabs, Row, Button, Col, Divider, Modal, Spin } from 'antd';

import './Step_3.css';

const { Content, Footer } = Layout;

@withRouter
@inject('translationsStore', 'step3RegistrationStore', 'profileStore', 'registrationStore', 'catalogStore')
@observer
class Step_3 extends Component {
  constructor(props) {
    super(props);

    this.props.registrationStore.setPosition(3);

    if (!this.props.step3RegistrationStore.session) {
      this.props.history.push('/registrations');
    }
  }

  componentDidMount() {
    const { step3RegistrationStore, profileStore, registrationStore } = this.props;
    const { customServicesCache } = step3RegistrationStore;
    const vehicleType = registrationStore.vehicleType ? registrationStore.vehicleType : 'car';

    if (customServicesCache.hasOwnProperty(step3RegistrationStore.session)) {
      registrationStore.setCustomMaintenances(customServicesCache[step3RegistrationStore.session]);
      const loadMaintenancesForm = { ...registrationStore.maintenances, custom: customServicesCache[step3RegistrationStore.session] };
      step3RegistrationStore.loadMaintenancesForm(loadMaintenancesForm);
    } else if (registrationStore.maintenances) {
      step3RegistrationStore.loadMaintenancesForm(registrationStore.maintenances);
    }

    if (vehicleType === 'car') {
      step3RegistrationStore.loadServicing()
        .then(() => {})
        .catch(() => {});
    }

    if (profileStore.profile.manageAlarms) {
      step3RegistrationStore.setCurrentTab('2');
      //load custom services from
    } else {
      step3RegistrationStore.setCurrentTab('1');
    }

    if (registrationStore.user) {
      ['agreementProfiling', 'agreementMarketing', 'agreementThirdParties'].forEach(key => {
        const { [key]: value } = registrationStore.user.assets[0].subscription;
        step3RegistrationStore.setFormField(`personalData.${key}`, value);
      });
    }
  }

  formValidateAsPromise = ref =>
    new Promise(resolve => {
      if (this[ref] && this[ref].getForm()) {
        this[ref].getForm().validateFields((error, values) => {
          if (error) {
            resolve({ error });
          } else {
            resolve({ values });
          }
        });
      } else {
        resolve({});
      }
    });

  agreementsValidateAsPromise = () => {
    const {
      translationsStore: { current: t }
    } = this.props;
    return new Promise(resolve => {
      let errors = {};
      ['agreementProfiling', 'agreementMarketing', 'agreementThirdParties'].forEach(agreement => {
        const { [agreement]: value } = this.props.step3RegistrationStore.formValues.personalData;
        if (value === undefined) errors = Object.assign({ ...errors }, { [agreement]: { errors: [{ message: t['errors']['step_3'][`${agreement}_invalid`] }] } });
      });
      if (Object.keys(errors).length > 0) {
        return resolve({ error: errors });
      } else {
        return resolve({});
      }
    });
  };

  onSubmitHandler = () =>
    Promise.all([this.formValidateAsPromise('product'), this.formValidateAsPromise('alarms'), this.personal.wrappedInstance.validate(), this.agreementsValidateAsPromise()]).then(
      ([productFormValidate, alarmsFormValidate, personalFormValidate, agreementsFormValidate]) => {
        if (!productFormValidate.error && !alarmsFormValidate.error && !personalFormValidate.error && !agreementsFormValidate.error) {
          //open modal and submit
          return this.props.step3RegistrationStore
            .submit()
            .then(result => {
              this.props.history.push('/registration/step_4');
              this.props.profileStore.pullUser();
            })
            .catch(error => {
              console.error(error);
              let errorObj = { title: 'Unknown error' };
              if (error) {
                let content = '',
                  title = '';
                try {
                  content = error.details ? error.details[0].message : error.content ? error.content.message : JSON.stringify(error);
                } catch (e) {
                  content = JSON.stringify(error);
                }
                try {
                  title = error.name ? error.name : '';
                } catch (e) {
                  title = '-';
                }
                Object.assign(errorObj, { title }, { content });
              }
              Modal.error(errorObj);
            });
        } else {
          let errors = [];
          forEachObjIndexed((value, key) => {
            errors = errors.concat(value.errors || value.variant.errors);
          }, Object.assign({}, productFormValidate.error || {}, alarmsFormValidate.error || {}, personalFormValidate.error || {}, agreementsFormValidate.error || {}));
          Modal.error({
            title: 'Validation error',
            content: (
              <Col>
                {errors.map((error, index) => {
                  return <Row key={`validation_error_${index}`}>{error.message}</Row>;
                })}
              </Col>
            )
          });
        }
      }
    );

  onTabClick(clickedTab) {
    this.props.step3RegistrationStore.setCurrentTab(clickedTab);
  }

  render() {
    const { step3RegistrationStore, profileStore, catalogStore, registrationStore } = this.props;
    const {
      translationsStore: { current: t }
    } = this.props;

    return (
      <Layout className="Step_3">
        {step3RegistrationStore.user && (
          <Row type="flex" style={{ flex: 'auto', display: 'flex', justifyContent: 'center' }}>
            <Col style={{ display: 'flex' }} xs={24} xl={18}>
              <Layout style={{ padding: '0 50px' }}>
                <Content style={{ display: 'flex' }}>
                  <Tabs animated={false} activeKey={step3RegistrationStore.activeKey} onTabClick={this.onTabClick.bind(this)}>
                    <Tabs.TabPane key="1" tab="" forceRender={true}>
                      <Spin spinning={catalogStore.inProgress} tip="Loading catalog...">
                        <ProductSelectionTabPane
                          ref={product => {
                            this.product = product;
                          }}
                        />
                      </Spin>
                    </Tabs.TabPane>
                    {profileStore.profile.manageAlarms && (
                      <Tabs.TabPane key="2" forceRender={true} tab="">
                        {!step3RegistrationStore.loadingServicing && (
                          <AlarmsTabPane
                            ref={alarms => {
                              this.alarms = alarms;
                            }}
                          />
                        )}
                        {step3RegistrationStore.loadingServicing && <Spin tip="Loading Infocar data..." />}
                      </Tabs.TabPane>
                    )}
                  </Tabs>
                </Content>
                <Footer>
                  <Divider style={{ marginTop: '0' }} />
                  <Row type="flex" justify="space-between" align="middle">
                    {step3RegistrationStore.activeKey === '1' && <PersonalData ref={personal => (this.personal = personal)} />}
                    {step3RegistrationStore.activeKey === '2' && <div />}
                    <Row>
                      {step3RegistrationStore.activeKey === '1' && profileStore.profile.manageAlarms && (
                        <Button id="go_to_alarm" onClick={() => step3RegistrationStore.setCurrentTab('2')}>
                          {t['shared']['btnGo_to_alarm']}
                        </Button>
                      )}

                      {step3RegistrationStore.activeKey === '1' && (
                        <Button id="submit_step_3" type="primary" loading={step3RegistrationStore.inProgress} onClick={this.onSubmitHandler}>
                          {t['shared']['btnSubmit_step_3']}
                        </Button>
                      )}

                      {step3RegistrationStore.activeKey === '2' && (
                        <Button
                          id="go_to_service"
                          onClick={() => {
                            const { manageAlarms = false } = profileStore.profile;
                            const { checked: customServicesChecked, services: customServices } = step3RegistrationStore.formValues.maintenances.customServices;
                            let customServicesValid = customServices
                              .map(service => {
                                return step3RegistrationStore.isServiceValid(service);
                              })
                              .reduce((acc, current) => (current === true ? acc : false), true);
                            customServicesValid = customServices.length > 0 && customServicesValid;
                            if (manageAlarms && customServicesChecked && !customServicesValid) {
                              Modal.error({ content: t['errors']['step_3']['services_invalid'] });
                            } else {
                              step3RegistrationStore.confirmDraftsCustomService();
                              registrationStore.setCustomMaintenances(customServices);
                              step3RegistrationStore.setCurrentTab('1');
                            }
                          }}
                        >
                          {t['shared']['btnGo_to_service']}
                        </Button>
                      )}
                    </Row>
                  </Row>
                </Footer>
              </Layout>
            </Col>
          </Row>
        )}
      </Layout>
    );
  }
}

export default Step_3;



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_3/Step_3.js